var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5C8.05228 14.5 8.5 14.0523 8.5 13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5C6.5 14.0523 6.94772 14.5 7.5 14.5Z",
    fill: "#EBF9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 14.5C12.719 14.5 13.1667 14.0523 13.1667 13.5C13.1667 12.9477 12.719 12.5 12.1667 12.5C11.6144 12.5 11.1667 12.9477 11.1667 13.5C11.1667 14.0523 11.6144 14.5 12.1667 14.5Z",
    fill: "#EBF9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.16667H5.38931L4.61998 3.32C4.51899 3.07677 4.34805 2.86899 4.12884 2.723C3.90963 2.57702 3.65202 2.49941 3.38865 2.5H1.83331V3.83334H3.38931L6.55131 11.4233C6.65465 11.6713 6.89798 11.8333 7.16665 11.8333H12.5C12.778 11.8333 13.0266 11.6607 13.1246 11.4013L15.1246 6.068C15.1621 5.96707 15.1746 5.85857 15.1612 5.75175C15.1477 5.64493 15.1087 5.54294 15.0473 5.45445C14.986 5.36596 14.9042 5.29358 14.8089 5.24348C14.7136 5.19338 14.6076 5.16703 14.5 5.16667ZM11.8333 9.16667H10.5V10.5H9.16665V9.16667H7.83331V7.83334H9.16665V6.5H10.5V7.83334H11.8333V9.16667Z",
    fill: "#EBF9FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartAdd);
export default __webpack_public_path__ + "static/media/cart-add.e58115d79dfd8b870fc5a455bddb47de.svg";
export { ForwardRef as ReactComponent };